import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { gameReducer, initialState as initialGameState } from '../features/game/gameSlice'
import { saveState, loadState } from './localStorage'

const storedState = loadState()

const initialState = {
  game: {
    ...initialGameState,
    myIdByGameId: storedState?.game.myIdByGameId || {},
  },
}

export const store = configureStore({
  reducer: {
    game: gameReducer,
  },
  preloadedState: initialState,
});

store.subscribe(() => saveState({
  game: {
    myIdByGameId: store.getState().game.myIdByGameId
  }
}))

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
